import React from 'react'

const Change: React.FC<DefaultPropsIcon> = (props) => {
  const { size = 20, onClick, className, color = '#818C99' } = props
  return (
    <span className={['anticon', 'anticon-setting', className || ''].join(' ')} onClick={onClick}>
      {/* <svg width={size} height={size} viewBox={`0 0 20 20`} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M9.53551 2.57496L7.86884 4.24163L2.83301 4.24163C2.40564 4.24163 2.05342 4.56333 2.00528 4.97778L1.99967 5.07497V13.4083C1.99967 13.8685 2.37277 14.2416 2.83301 14.2416H11.1663C11.6266 14.2416 11.9997 13.8685 11.9997 13.4083V8.35996L13.6663 6.6933V13.4083C13.6663 14.789 12.5471 15.9083 11.1663 15.9083H2.83301C1.4523 15.9083 0.333008 14.789 0.333008 13.4083V5.07497C0.333008 3.69425 1.4523 2.57497 2.83301 2.57497L9.53551 2.57496ZM11.7647 2.70163L13.533 4.46913L8.07327 9.92917C7.68707 10.3154 7.21188 10.6008 6.68951 10.7602L5.24 11.2027C5.15197 11.2296 5.05881 11.18 5.03194 11.092C5.02225 11.0603 5.02225 11.0264 5.03194 10.9947L5.47444 9.54517C5.63391 9.0228 5.9193 8.54761 6.3055 8.16141L11.7647 2.70163ZM15.2019 1.03274C15.6901 1.5209 15.6901 2.31235 15.2019 2.80051L14.3163 3.68496L12.5488 1.91746L13.4342 1.03274C13.9223 0.544587 14.7138 0.544587 15.2019 1.03274Z"
          fill={color}
        />
      </svg> */}

      <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12.53 3.57L10.86 5.24L5.83 5.24C5.4 5.24 5.05 5.56 5 5.97L5 6.07L5 14.4C5 14.86 5.37 15.24 5.83 15.24L14.16 
              15.24C14.62 15.24 15 14.86 15 14.4L15 9.36L16.66 7.69L16.66 14.4C16.66 15.78 15.54 16.9 14.16 16.9L5.83 16.9C4.45 
              16.9 3.33 15.78 3.33 14.4L3.33 6.07C3.33 4.69 4.45 3.57 5.83 3.57L12.53 3.57ZM14.76 3.7L16.53 5.46L11.07 10.92C10.68 
              11.31 10.21 11.6 9.68 11.76L8.24 12.2C8.15 12.23 8.05 12.18 8.03 12.09C8.02 12.06 8.02 12.02 8.03 11.99L8.47 10.54C8.63 
              10.02 8.91 9.54 9.3 9.16L14.76 3.7ZM18.2 2.03C18.69 2.52 18.69 3.31 18.2 3.8L17.31 4.68L15.54 2.91L16.43 2.03C16.92 
              1.54 17.71 1.54 18.2 2.03Z"
          fill={color}
        />
      </svg>
    </span>
  )
}

export default Change
